export default __webpack_public_path__ + "static/media/logo-innovation.cc20d84e.png";